import { api } from 'boot/axios.js'

export async function session(ctx, queryParams = {}) {
  try {
    const response = await api({
      url: '/auth/session',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('item', response.data)
    ctx.commit('pagination', response.data.pagination)
    return response
  } catch (e) {
    return e
  }
}

export async function client(ctx, data) {
  try {
    ctx.commit('client', data)
  } catch (e) {
    return e
  }
}
